<template src="./html/Staff.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import DepartmentModal from './../../../departments/views/Modal.vue'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'data', 'item', 'project'],
		components: {
			'department-modal': DepartmentModal,
			'multiselect': Multiselect,
		},
		data () {
			return {
				toggle: false,

				closed_task: {
					closing_id: null,
					task_id: null,
					schedule_id: null,
					user: null,
					user_id: null,
					customer: null,

					start: null,
					end: null,

					total_time: null,
					closing_time: null,
					total_time_spent: null,
					rest_subject: null,
					rest_time: null,
					comment: null,
				},

				departments: [],
				department: null,
				newUsers: [],
				schedule: null,

				options: [],
				isLoading: false,

				closing_time: {
					hours: null,
					minutes: null,
				},

				rest_time: {
					hours: null,
					minutes: null,
				},

				start: null,
				end: null,
			}
		},
		watch: {
			'closed_task.closing_time'() {
				if(this.closed_task.closing_time) {
					var closing_time = this.closed_task.closing_time
				} else {
					var closing_time = 0
				}

				var duration = moment.duration().add(closing_time, 'seconds')

				var hours = parseInt(duration.asHours())
				var minutes = parseInt(duration.minutes())

				this.closing_time.hours = hours
				this.closing_time.minutes = minutes
			},
			'closed_task.rest_time'() {
				if(this.closed_task.rest_time) {
					var rest_time = this.closed_task.rest_time
				} else {
					var rest_time = 0
				}

				var duration = moment.duration().add(rest_time, 'seconds')

				var hours = parseInt(duration.asHours())
				var minutes = parseInt(duration.minutes())

				this.rest_time.hours = hours
				this.rest_time.minutes = minutes
			},
			//-- closing_time
				'closing_time.hours': function () {
					if(this.closing_time.hours) {
						this.closing_time.hours = parseInt(this.closing_time.hours)
					} else {
						this.closing_time.hours = null
					}
					this.setClosingTime()
					this.calculateTotalTimeSpent()
					//this.calculateRestTime()
				},
				'closing_time.minutes': function () {
					if(this.closing_time.minutes) {
						this.closing_time.minutes = parseInt(this.closing_time.minutes)
						if(this.closing_time.minutes > 59) {
							this.closing_time.minutes = 59
						}
					} else {
						this.closing_time.minutes = null
					}
					this.setClosingTime()
					this.calculateTotalTimeSpent()
					//this.calculateRestTime()
				},
			//-- rest_time
				'rest_time.hours': function () {
					if(this.rest_time.hours) {
						this.rest_time.hours = parseInt(this.rest_time.hours)
					} else {
						this.rest_time.hours = null
					}
					this.setRestTime()
					this.calculateTotalTimeSpent()
				},
				'rest_time.minutes': function () {
					if(this.rest_time.minutes) {
						this.rest_time.minutes = parseInt(this.rest_time.minutes)
						if(this.rest_time.minutes > 59) {
							this.rest_time.minutes = 59
						}
					} else {
						this.rest_time.minutes = null
					}
					this.setRestTime()
					this.calculateTotalTimeSpent()
				},
			item() {
				this.filterUsers()
			},
			schedule() {
				if(!this.closed_task.closing_id) {
					if(this.schedule) {
						this.closed_task.schedule_id = this.schedule.id
					} else {
						this.closed_task.schedule_id = null
					}
				}
			}
		},
		mounted() {
			this.closed_task.task_id = this.item.id
			this.filterUsers()
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				if(!this.user.hasRole('external_manager')) {
					this.getDepartments()
				}
			},
			getDepartments() {
				this.$http.get('admin/departments')
				.then(response => {
					this.departments = response.body
				})
			},

			setClosingTime() {
				if(this.closing_time.hours) {
					var hours = this.closing_time.hours
				} else {
					var hours = 0
				}

				if(this.closing_time.minutes) {
					var minutes = this.closing_time.minutes
				} else {
					var minutes = 0
				}

				var duration = moment.duration().add(hours, 'hours').add(minutes, 'minutes')

				var seconds = duration.asSeconds()

				this.closed_task.closing_time = seconds
			},

			setRestTime() {
				if(this.rest_time.hours) {
					var hours = this.rest_time.hours
				} else {
					var hours = 0
				}

				if(this.rest_time.minutes) {
					var minutes = this.rest_time.minutes
				} else {
					var minutes = 0
				}

				var duration = moment.duration().add(hours, 'hours').add(minutes, 'minutes')

				var seconds = duration.asSeconds()

				this.closed_task.rest_time = seconds
			},

			dateChange() {
				if(!this.closed_task.closing_id) {
					var start = moment(this.closed_task.start)
					var end = moment(this.closed_task.end)

					if(end.isValid() && start.isValid()) {
						var diff = end.diff(start)

						var seconds = moment.duration(diff).asSeconds()

						this.closed_task.total_time = seconds
						this.closed_task.closing_time = seconds
						this.closed_task.total_time_spent = seconds
					}
				}
			},

			calculateTotalTime(update) {
				var start = moment(this.closed_task.start)
				var end = moment(this.closed_task.end)

				if(end.isValid() && start.isValid()) {
					var diff = end.diff(start)

					var seconds = moment.duration(diff).asSeconds()

					this.closed_task.total_time = seconds
				}
			},

			calculateTotalTimeSpent() {
				var closing_time = this.closed_task.closing_time
				var rest_time = this.closed_task.rest_time

				var seconds = closing_time - rest_time
				this.closed_task.total_time_spent = seconds
			},

			closedTaskUser(user = null, tasks_closing = null) {
				this.clearData()
				if(user) {
					this.closed_task.user = user
					this.closed_task.user_id = user.id
					if(!this.toggle) {
						this.toggle = true
					} else {
						this.toggle = true
					}
				}

				if(!tasks_closing) {
					if(user) {
						if(user.tasks_closing) {
							if(user.tasks_closing.length) {
								user.tasks_closing.map(function(e) {
									for (var i = 0; i < user.schedules.length; i++) {
										var element = user.schedules[i]
										if(element.id == e.schedule_id) {
											user.schedules.splice(i, 1)
										}
									}
								})
							}
						}
					}
				}

				//-- Edit closing
				if(tasks_closing) {
					this.closed_task.closing_id = tasks_closing.id
					this.closed_task.schedule_id = tasks_closing.schedule_id
					this.closed_task.user_id = tasks_closing.user_id
					this.closed_task.start = moment(tasks_closing.start).toISOString()
					this.closed_task.end = moment(tasks_closing.end).toISOString()
					this.closed_task.total_time = tasks_closing.total_time
					this.closed_task.closing_time = tasks_closing.closing_time
					this.closed_task.total_time_spent = tasks_closing.total_time_spent
					this.closed_task.rest_subject = tasks_closing.rest_subject
					this.closed_task.rest_time = tasks_closing.rest_time
					this.closed_task.comment = tasks_closing.comment
					/*
					var start = moment(closing.start).toISOString()
					var end = moment(closing.end).toISOString()

					this.start = start
					this.end = end

					this.closed_task.start = start
					this.closed_task.end = end

					this.closed_task.total_time = closing.total_time
					this.closed_task.closing_time = closing.closing_time
					this.closed_task.rest_time = closing.rest_time
					this.closed_task.total_time_spent = closing.total_time_spent

					this.closed_task.comment = closing.comment
					this.closed_task.closing_id = closing.id
					this.closed_task.rest_subject = closing.rest_subject*/
				}/* else if(schedules) {
					var closing = this.item.schedules[0]

					var start = moment(closing.estimated_start)
					var end = moment(closing.estimated_end)

					this.closed_task.start = start.toISOString()
					this.closed_task.end = end.toISOString()
				}*/
				this.closed_task.customer = null
			},
			close() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.closure_be_made"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.formatData()
							if(that.closed_task.user) {
								var api = 'admin/projects/tasks/closing/users'
							} else if(that.closed_task.customer) {
								var api = 'admin/projects/tasks/closing/cutomers'
							}
							that.$http.post(api, that.closed_task)
							.then(response => {
								that.toggle = false
								that.$emit('reload')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			updateClosing() {
				this.formatData()
				if(this.closed_task.user) {
					var l = Ladda.create(document.querySelector("#btn-update-closing"))
					var api = 'admin/projects/tasks/closing/users/'+this.closed_task.closing_id
				} else if(this.closed_task.customer) {
					var l = Ladda.create(document.querySelector("#btn-update-closing-customer"))
					var api = 'admin/projects/tasks/closing/cutomers/'+this.closed_task.closing_id
				}
				l.start()
				this.$http.put(api, this.closed_task)
				.then(response => {
					l.stop()
					this.$emit('reload')
					this.toggle = false
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					l.stop()
					console.log(response)
				})
			},
			clearData() {
				this.toggle = false

				this.closed_task.closing_id = null
				this.closed_task.schedule_id = null
				this.closed_task.user = null
				this.closed_task.user_id = null
				this.closed_task.customer = null
				this.closed_task.start = null
				this.closed_task.end = null
				this.closed_task.total_time = null
				this.closed_task.closing_time = null
				this.closed_task.total_time_spent = null
				this.closed_task.rest_subject = null
				this.closed_task.rest_time = null
				this.closed_task.comment = null

				this.schedule = null
			},
			openModal(id) {
				$('#'+id).modal('show')
			},
			closeModal(id) {
				$('#'+id).modal('hide')
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							department_id: null,
							team_id: null,
						}
					}

					if(this.project) {
						data.filter.team_id = this.project.team_id
					}

					if(this.department) {
						data.filter.department_id = this.department.id
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
						this.filterUsers()
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
			filterUsers () {
				if(this.project) {
					if(this.project.team) {
						if(this.project.team.users) {
							if(this.project.team.users.length) {

								this.options = this.project.team.users
								var that = this
								this.item.users.map(function(e) {
									for (var i = 0; i < that.options.length; i++) {
										var element = that.options[i]
										if(element.id == e.id) {
											that.options.splice(i, 1)
										}
									}
								})
							}
						}
					} else {
						if(this.item) {
							if(this.item.users) {
								if(this.item.users.length) {
									if(this.options) {
										if(this.options.length) {
											var that = this
											this.item.users.map(function(e) {
												for (var i = 0; i < that.options.length; i++) {
													var element = that.options[i]
													if(element.id == e.id) {
														that.options.splice(i, 1)
													}
												}
											})
										}
									}
								}
							}
						}
					}
				}
			},
			storeUsers() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				if(this.newUsers.length) {
					var data = {
						users: this.newUsers,
					}
					this.$http.post('admin/projects/tasks/'+this.item.id+'/add/users', data)
					.then(response => {
						loading.stop()
						swal(response.body.title, response.body.text, response.body.type)
						this.closeModal('modal-add-user')
						this.newUsers = []
						this.department = null
						this.options = []
						this.$emit('reload')
					}).catch(function(response) {
						console.log(response)
						loading.stop()
						this.closeModal('modal-add-user')
						this.newUsers = []
						this.department = null
					})
				}
			},
			quitUser(user) {
				let index = this.newUsers.indexOf(user)
				this.newUsers.splice(index, 1)
			},
			destroy (user) {
				if(user) {
					var text = this.$t("messages.item_can_not_be_retrieved")

					if(user.schedules) {
						if(user.schedules.length) {
							text = 'Este usuario ' + user.email + ' tiene una fecha establecida en el calendario para esta tarea, si lo elimina también se eliminará del calendario'
						}
					}

					var that = this
					var task_id = this.item.id
					swal.queue([{
						title: this.$t("messages.attention"),
						text: text,
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.delete('admin/projects/tasks/' + task_id + '/users/' + user.id)
								.then(response => {
									that.$emit('reload')
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type
									})
								}).catch(function(response) {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								})
							}).catch((result) => {
								console.log(result)
							})
						}
					}])
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			formatData() {
				if(this.closed_task.start) {
					var start = moment(this.closed_task.start)
					this.closed_task.start = start.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.closed_task.end) {
					var end = moment(this.closed_task.end)
					this.closed_task.end = end.format('YYYY-MM-DD H:mm:ss')
				}
			},
			scheduleSelected() {
				if(this.schedule) {
					var closing = this.schedule

					var start = moment(closing.estimated_start)
					var end = moment(closing.estimated_end)

					this.closed_task.start = start.toISOString()
					this.closed_task.end = end.toISOString()

					this.dateChange()
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Staff.vue